import { Alert as MuiAlert, AlertProps as MuiAlertProps } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledAlert = styled(MuiAlert)<MuiAlertProps>(
  ({ theme: { palette, spacing } }) => ({
    // Alert root
    alignItems: 'center',
    minWidth: spacing(34.4),
    padding: spacing(0.4, 1.6),

    // Alert Message/Text div
    '& .MuiAlert-message': {
      padding: '0',
    },

    // Alert Action button
    '& .MuiAlert-action': {
      padding: spacing(0, 0, 0, 1),

      '& .MuiIconButton-root': {
        padding: spacing(0.8),
        color: palette.common.white,
      },
    },
  })
);

export default StyledAlert;
